{
  "prefsFor": "{{email}}"
}